import { Component,Inject,OnInit } from '@angular/core';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-selected-customer-group-dialog',
  standalone: true,
  imports: [CommonModule,MatButtonModule],
  templateUrl: './selected-customer-group-dialog.component.html',
  styleUrl: './selected-customer-group-dialog.component.scss'
})
export class SelectedCustomerGroupDialogComponent implements OnInit{


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SelectedCustomerGroupDialogComponent>
  ) {}


  ngOnInit(): void {
      console.log(this.data)
  }
  getGroupNames(groups: any[]): string {
    return groups.map(g => g.groupName).join(', ');
  }

  /** True only when at least one Customer + Group target will be sent to the publish API. */
  get hasValidSelection(): boolean {
    const payload = this.data?.payload;
    return Array.isArray(payload) && payload.length > 0;
  }

  onConfirm()
  {
    if (!this.hasValidSelection) {
      return;
    }
    this.dialogRef.close(true)
  }
  onCancel()
  {
    this.dialogRef.close();
  }

}
